// Module
var code = `<div class="toke-modal"
    ng-if="\$ctrl.isOpen">

    <div class="toke-modal__overlay"
        ng-click="\$ctrl.close()">
    </div>

    <div class="toke-modal__container">

        <button type="button"
            class="toke-modal__close"
            aria-label="Cerrar modal"
            ng-click="\$ctrl.close()">
        </button>

        <div class="toke-modal__content">

            <h2 class="toke-modal__title">
                {{\$ctrl.modalData.title}}
            </h2>

            <div class="toke-modal__subtitle"
                ng-bind-html="\$ctrl.modalData.subtitle"></div>


            <div class="toke-modal__qr">
                <img class="toke-modal__qr-image"
                    ng-src="{{\$ctrl.modalData.qrImage}}"
                    alt="Código QR toke">
            </div>

        </div>

    </div>

</div>`;
// Exports
export default code;